import { render, staticRenderFns } from "./AdminAlertPayerList.vue?vue&type=template&id=24f97fec&scoped=true"
import script from "./AdminAlertPayerList.vue?vue&type=script&lang=js"
export * from "./AdminAlertPayerList.vue?vue&type=script&lang=js"
import style0 from "./AdminAlertPayerList.vue?vue&type=style&index=0&id=24f97fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f97fec",
  null
  
)

export default component.exports